import type { Artwork } from "./api";

export const FALLBACK_ARTWORKS: Artwork[] = [
  {
    id: 1,
    slug: "birds-in-bloom",
    title_it: "Whispers of Spring",
    description_it: "Opera originale con uccelli e fiori su fondo luminoso.",
    title_en: "Whispers of Spring",
    description_en: "Original artwork with birds and flowers on a luminous ground.",
    category: "original",
    technique: "Oil on canvas",
    dimensions: null,
    year: null,
    price: 1200,
    currency: "EUR",
    status: "available",
    featured: 1,
    image_key: null,
    image_url: "/images/hero-artwork.jpg",
    additional_images: null,
    stock_quantity: 1,
    created_at: "",
    updated_at: "",
  },
  {
    id: 2,
    slug: "garden-light",
    title_it: "The Secret Garden",
    description_it: "Opera originale ispirata alla luce del giardino.",
    title_en: "The Secret Garden",
    description_en: "Original artwork inspired by garden light.",
    category: "original",
    technique: "Oil on canvas",
    dimensions: null,
    year: null,
    price: 950,
    currency: "EUR",
    status: "available",
    featured: 1,
    image_key: null,
    image_url: "/images/original-category.jpg",
    additional_images: null,
    stock_quantity: 1,
    created_at: "",
    updated_at: "",
  },
  {
    id: 3,
    slug: "koi-study",
    title_it: "Koi Study",
    description_it: "Stampa d'arte con composizione di koi.",
    title_en: "Koi Study",
    description_en: "Art print with a koi composition.",
    category: "print",
    technique: "Fine art print",
    dimensions: null,
    year: null,
    price: 110,
    currency: "EUR",
    status: "available",
    featured: 1,
    image_key: null,
    image_url: "/images/print-category.jpg",
    additional_images: null,
    stock_quantity: 25,
    created_at: "",
    updated_at: "",
  },
];

export function getFallbackArtworkBySlug(slug: string): Artwork | undefined {
  return FALLBACK_ARTWORKS.find((artwork) => artwork.slug === slug);
}
